import { flexRender } from '@tanstack/react-table';
import classNames from 'classnames/bind';
import React from 'react';

import styles from './TableBodyRow.module.scss';

const cx = classNames.bind(styles);

const TableBodyRow = ({ row, virtualRow, rowVirtualizer }) => {
  return (
    <tr
      key={row.id}
      data-index={virtualRow.index}
      ref={(node) => rowVirtualizer.measureElement(node)}
      style={{
        transform: `translateY(${virtualRow.start}px)`,
      }}
      className={cx('row')}>
      {row.getVisibleCells().map((cell) => (
        <td key={cell.id} style={{ width: cell.column.getSize() }}>
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </td>
      ))}
    </tr>
  );
};

export default TableBodyRow;
